<template>
  <div class="mx-auto home">
    <div class="max-w-7xl mx-auto rounded-lg relative">
      <div class="hidden lg:flex flex-row mt-12 lg:block lg:px-12 xl:px-0">
        <div class="lg:w-2/5">
          <div class="lg:-mt-4 mt-4">
            <div
              class=" text-3xl md:text-3xl lg:text-3xl xl:text-3xl tracking-wide font-semibold text-darkFont w-full text-justify"
            >
              <justified-header-text
                text="WELCOME TO OUR 2025"
              ></justified-header-text>
            </div>
            <div
                class="text-3xl md:text-3xl lg:text-3xl xl:text-3xl tracking-wide font-semibold text-darkFont w-full text-justify"
            >
              <p class="text-center">USER GROUP MEETING</p>
              <p class="text-center text-xl">Tune in 16th & 17th October from the comfort of your own home!</p>
            </div>
          </div>
        </div>

        <div class="lg:w-3/5 w-full">
          <div class="lg:flex justify-end mx-auto"></div>
        </div>
        <div class="lg:w-2/5 w-full">
          <!--<div class="lg:flex justify-end mx-auto">
            <img
              src="/images/TAKE_THE_TOUR.png"
              alt="Take The Tour"
              width="498"
              height="286"
              class="mx-auto corners cursor-pointer"
              @click="openModalTakeTour"
            />
          </div>-->
        </div>
      </div>
    </div>

    <div
      class="mx-auto pb-8 pt-12 xl:pt-0 margin-minus overflow-x-auto flex"
      id="themaps"
    >
      <div class="xl:w-1/12 w-full hidden lg:block">
        <div class="lg:flex justify-end mx-auto"></div>
      </div>
      <div class="xl:w-10/12 w-full mx-auto">
        <div class="block lg:flex flex-row justify-center mx-auto">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1372 1037"
            overflow="visible"
            class="h-auto svgmap overflow-x-auto px-20 lg:px-6 xl:px-0"
            id="themap"
          >
            <image
              width="1372"
              height="1037"
              xlink:href="/images/Map_2025_Subscribe_NowNEW.png"
            ></image>

            <!-- PRESENTER -->
            <rect
              class="cursor-pointer"
              @mouseover="overIcon('PRESENTER')"
              id="presenter_hit_circle"
              opacity="0.0"
              fill="white"
              x="405"
              y="0"
              width="229"
              height="275"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('PRESENTER')"
                @click="$router.push('/speakers')"
                v-show="show('PRESENTER')"
                width="229"
                xlink:href="/images/PNGs_Presenters_2024.png"
                style="filter:url(#shadowFilter)"
                x="407"
                y="0"
                overflow="visible"
              ></image>
            </transition>

            <!-- TEAM -->
            <rect
              class="cursor-pointer"
              @mouseover="overIcon('TEAM')"
              id="team_hit_circle"
              opacity="0.0"
              fill="white"
              x="0"
              y="211"
              width="215"
              height="275"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('TEAM')"
                @click="openModalMeetTeam"
                style="filter:url(#shadowFilter)"
                v-show="show('TEAM')"
                width="215"
                xlink:href="/images/PNGs_The_Team_2024.png"
                x="0"
                y="215"
                overflow="visible"
              ></image>
            </transition>

            <!-- SHOW -->
            <rect
              class="cursor-pointer"
              @mouseover="overIcon('PAST')"
              id="show_hit_circle"
              opacity="0.0"
              fill="white"
              x="178"
              y="558"
              width="215"
              height="275"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                style="filter:url(#shadowFilter)"
                @mouseout="outIcon('PAST')"
                @click="$router.push('/previous')"
                v-show="show('PAST')"
                width="215"
                xlink:href="/images/PNGs_Past_Events.png"
                x="178"
                y="550"
                overflow="visible"
              ></image>
            </transition>

            <!-- CHAT -->
            <rect
              class="cursor-pointer"
              @mouseover="overIcon('FAQ')"
              id="chat_hit_circle"
              opacity="0.0"
              fill="white"
              x="616"
              y="765"
              width="215"
              height="275"
            ></rect>

            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('FAQ')"
                @click="$router.push('/faq')"
                style="filter:url(#shadowFilter)"
                v-show="show('FAQ')"
                width="215"
                xlink:href="/images/PNGs_FAQs.png"
                x="618"
                y="758"
                overflow="visible"
              ></image>
            </transition>

            <!-- MAKING -->
            <rect
              class="cursor-pointer"
              @mouseover="() => overIcon('LIVEINTHELABS')"
              id="making_circle"
              opacity="0.0"
              fill="white"
              x="1165"
              y="487"
              width="215"
              height="275"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('LIVEINTHELABS')"
                @click="$router.push('/liveinthelabs')"
                v-show="show('LIVEINTHELABS')"
                style="filter:url(#shadowFilter)"
                width="215"
                xlink:href="/images/PNGs_Liveinthelabs_2025.png"
                x="1157"
                y="480"
                overflow="visible"
              ></image>
            </transition>

            <!-- SHOP -->
            <rect
              class="cursor-pointer"
              @mouseover="() => overIcon('SHOP')"
              id="shop_hit_circle"
              opacity="0.0"
              fill="white"
              x="948"
              y="80"
              width="215"
              height="275"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('SHOP')"
                @click="$router.push('/purchase')"
                style="filter:url(#shadowFilter)"
                v-show="show('SHOP')"
                width="215"
                xlink:href="/images/PNGs_Shop_2024.png"
                x="949"
                y="87"
                overflow="visible"
              ></image>
            </transition>

            <!-- WATCH -->
            <rect
              class="cursor-pointer"
              @mouseover="() => overIcon('SUBSCRIBE')"
              id="gallery_hit_circle"
              opacity="0.0"
              fill="white"
              x="563"
              y="316"
              width="325"
              height="325"
            ></rect>
            <transition
              enter-active-class="ease-out duration-125"
              enter-class="opacity-0 scale-90"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-100"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-90"
            >
              <image
                class="cursor-pointer"
                @mouseout="outIcon('SUBSCRIBE')"
                @click="$router.push('/subscribe')"
                style="filter:url(#shadowFilter)"
                v-show="show('SUBSCRIBE')"
                width="325"
                xlink:href="/images/PNGs_book_now.png"
                x="563"
                y="316"
                overflow="visible"
              ></image>
            </transition>
          </svg>
        </div>
      </div>
      <div class="xl:w-1/12 w-full hidden lg:block">
        <div class="lg:flex justify-end mx-auto"></div>
      </div>
    </div>

    <div class="bg-greyGradient">
      <div class="block mt-12">
        <div class="agenda">
          <paper-agenda></paper-agenda>
        </div>
      </div>
    </div>

    <!--<transition name="modal-fade" v-if="modalTakeTour">
      <div class="modal-backdrop" role="dialog">
        <div class="modal" ref="modal">
          <header class="modal-header">
            <div
              class="flex justify-between items-center absolute top-12 right-12"
            >
              <button
                class="ml-10 px-2 py-1 font-bold rounded-md text-white"
                @click="closeModalTakeTour"
                aria-label="Close modal"
              >
                CLOSE X
              </button>
            </div>
          </header>

          <section class="modal-body">
            <video
              width="960"
              height="540"
              poster="/images/TAKE_THE_TOUR.png"
              class="mx-auto lg:mx-0 corners cursor-pointer max-w-full"
              controls
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/usergroupmeeting-2023.appspot.com/o/Take%20the%20Tour%20Video.mp4?alt=media&token=511e544a-2377-4cff-aea4-f8fc1491faa4&_gl=1*1n7oot4*_ga*NTY0MTA4ODM1LjE2OTU2Mzk3MTQ.*_ga_CW55HF8NVT*MTY5NjM1MjQ3MC4yMi4xLjE2OTYzNTI1NDMuNjAuMC4w"
                type="video/mp4"
              />
            </video>
          </section>

          <footer class="modal-footer">
            <div class="flex justify-center p-5">
              <div class="flex justify-around"></div>
            </div>
          </footer>
        </div>
      </div>
    </transition> -->

   <!-- <transition name="modal-fade" v-if="modalMakingVictor">
      <div class="modal-backdrop" role="dialog">
        <div class="modal" ref="modal">
          <header class="modal-header">
            <div
              class="flex justify-between items-center absolute top-12 right-12"
            >
              <button
                class="ml-10 px-2 py-1 font-bold rounded-md text-white"
                @click="closeModalMakingVictor"
                aria-label="Close modal"
              >
                CLOSE X
              </button>
            </div>
          </header>

          <section class="modal-body max-w-full">
            <iframe
              class="youtube-video"
              src="https://www.youtube.com/embed/n1kPjD74a24?si=kT8FJzfMDtMPmFAt"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </section>

          <footer class="modal-footer">
            <div class="flex justify-center p-5">
              <div class="flex justify-around"></div>
            </div>
          </footer>
        </div>
      </div>
    </transition> -->

    <transition name="modal-fade" v-if="modalMeetTeam">
      <div class="modal-backdrop" role="dialog">
        <div class="modal" ref="modal">
          <header class="modal-header">
            <div
              class="flex justify-between items-center absolute top-12 right-12"
            >
              <button
                class="ml-10 px-2 py-1 font-bold rounded-md text-white"
                @click="closeModalMeetTeam"
                aria-label="Close modal"
              >
                CLOSE X
              </button>
            </div>
          </header>

          <section class="modal-body max-w-full">
            <iframe
              class="youtube-video"
              src="https://www.youtube.com/embed/2rOrYqoZowI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </section>

          <footer class="modal-footer">
            <div class="flex justify-center p-5">
              <div class="flex justify-around"></div>
            </div>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PaperAgenda from "../components/PaperAgenda";
import JustifiedHeaderText from "../components/JustifiedHeaderText";
import { sanityClient } from "../utils/sanity";

export default {
  name: "FestivalHome",
  components: { JustifiedHeaderText, PaperAgenda },
  data() {
    return {
      shown: "",
      modalTakeTour: false,
      modalMeetTeam: false,
      //modalMakingVictor: false,
      groupedSessions: {}
    };
  },
  mounted: function() {
    this.fetchSessions();
    this.pollData();
    let goto =
      document.getElementById("themap").clientWidth -
      document.getElementById("themaps").clientWidth;
    goto = goto / 2;
    document.getElementById("themaps").scroll(goto, 0);
  },
  beforeDestroy() {
    if (this.polling) {
      clearInterval(this.polling);
    }
  },
  computed: {
  },
  methods: {
    show(icon) {
      return icon === this.shown;
    },
    overIcon(icon) {
      this.shown = icon;
    },
    outIcon(icon) {
      if (this.shown === icon) {
        this.shown = "";
      }
    },
    openModalTakeTour() {
      this.modalTakeTour = true;
    },
    closeModalTakeTour() {
      this.modalTakeTour = false;
    },
    //openModalMakingVictor() {
      //this.modalMakingVictor = true;
    //},
    //closeModalMakingVictor() {
      //this.modalMakingVictor = false;
    //},
    openModalMeetTeam() {
      this.modalMeetTeam = true;
    },
    closeModalMeetTeam() {
      this.modalMeetTeam = false;
    },
    pollData() {
      this.polling = setInterval(() => {
        this.fetchSessions();
      }, 30000);
    },
    selectIndex(idx) {
      this.selectedIndex = idx;
      this.selectedSessionKey = this.dates[idx];
    },
    setDate(date) {
      this.selectedSessionKey = date;
    },
    urlValue(session) {
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session'] | order(startTime desc) {speakers[]->{name, _id},watchStatus,slug}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          const liveidle = [];
          res.reduce((groups, session) => {
            if (
              session.watchStatus === "LIVE" ||
              session.watchStatus === "IDLE"
            ) {
              liveidle.push(session);
            }
            return liveidle;
          }, {});

          this.groupedSessions = liveidle;
          this.urlValue(liveidle);
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.corners {
  border-radius: 16px;
}

/* width */
::-webkit-scrollbar {
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #adadad;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fcc209;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fcc209;
}



.margin-minus {
  margin-top: -1.5rem;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  background: none;
}

.svgmap {
  width: 80rem;
  max-width: 80rem;
}
.youtube-video {
  aspect-ratio: 16 / 9;
  width: 800px;
  max-width: 100%;
}

.bg-greyGradient {
  background: rgb(188,188,188);
  background: -moz-linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
  background: -webkit-linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
  background: linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcbcbc",endColorstr="#adadad",GradientType=1);
  background: #bcbcbc;
}

@media only screen and (max-width: 1024px) {
  .svgmap {
    width: 1200px;
  }
}
@media only screen and (max-width: 768px) {
  .svgmap {
    width: 1000px;
  }
  .modal-body {
    width: 600px;
  }
}
@media only screen and (max-width: 640px) {
  .svgmap {
    width: 800px;
  }
  .modal-body {
    width: 320px;
  }
}
</style>
